import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createMaintenance } from '../../services'
import { toast } from 'sonner'
import { BankQueryKeys } from '@/modules/bank/keys'
import { CreateMaintenanceRequest } from '@/modules/bank/type'

export default function useMutationCreateMaintenance() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			payload,
			maintenanceKey,
		}: {
			payload: CreateMaintenanceRequest
			maintenanceKey: string
		}) => createMaintenance(payload, maintenanceKey),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.Maintenances],
			})
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.MaintenancesAll],
			})
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.PaymentGateways],
			})
			toast.success('สร้างการซ่อมบำรุงสำเร็จ')
		},
	})
}
